module.exports = __webpack_public_path__ + "img/banner1.8fcaebb4.png";